var Connection = require('connection');
var RenderReasons = require('renderreasons');
var Formatter = require('formatter');
var SelectAutoComplete = require('selectautocomplete');
var AvatarUploadPreview = require('./avataruploadpreview.es6').default;
var util = require('../lib/util.es6');


var NetworkEditor = Backbone.View.extend({
    tagName: 'form',
    initialize: function (options) {
        this.$el.addClass('networkEditor');
        this.session = options.session;
        
        this.idPrefix = options.idPrefix || '';
        this.classPrefix = options.classPrefix || '';
        this.action = options.action;
        this.prepareFormData = options.prepareFormData;
        this.callback = options.callback;
        this.extraFields = options.extraFields;
        this.cellGroups = options.cellGroups;
        this.submitLabel = options.submitLabel || 'Submit';
        this.cancelLabel = options.cancelLabel || 'Cancel';
        this.tabFocus = options.tabFocus || 'Nick';
        this.cancel = options.cancel;
        this.afterSubmit = $.makeArray(options.afterSubmit);
        
        this.inputs = {};
        this.cells = {};
        this.nameMap = {};
        this.containers = {};
        this.error = null;
        this.submit = null;
        this.networkComplete = null;
        this.formatter = new Formatter();
    },
    events: {
        'load': 'onLoad',
        'submit': 'onSubmit',
        'click label': 'clickLabel',
        'change input.reveal[type=checkbox]': 'changeRevealPass'
    },
    onLoad: function (e) {
        // Load networks
        this.session.getNetworks(_.bind(function (response) {
            // Build option list
            var hostnameEl = this.input('Hostname');
            if (hostnameEl) {
                hostnameEl.html(this.$('.placeholder'));
                _.each(response.networks, function (net, i) {
                    _.each(net.servers, function (server, j) {
                        var option = $('<option>')
                            .text(net.name)
                            .data('hostname', server.hostname)
                            .data('port', server.port)
                            .data('ssl', server.ssl);
                        hostnameEl.append(option);
                    }, this);
                }, this);
            }
        }, this));
    },
    isDisabled: function () {
        return this.disabled;
    },
    disableForm: function () {
        if (!this.isDisabled()) {
            this.disabled = true;
            this.$('input, button, textarea').blur().prop('disabled', true);
        }
    },
    enableForm: function () {
        if (this.isDisabled()) {
            this.disabled = false;
            this.$('input, button, textarea').prop('disabled', false);
        }
    },
    clickLabel: function (e) {
        var forId = $(e.target).attr('for');
        if (this.networkComplete && $('#' + forId).is(this.networkComplete.el)) {
            this.networkComplete.focus();
        }
    },
    changeRevealPass: function (e) {
        var t = $(e.target);
        var input = t.data('input');
        if (t.is(':checked')) {
            input.removeAttr('type');
        } else {
            input.attr('type', 'password');
        }
    },
    formData: function () {
        var data = this.serializeForm();
        if (this.prepareFormData) {
            return this.prepareFormData(data);
        } else {
            return data;
        }
    },
    onSubmit: function (e) {
        e.preventDefault();
        if (this.isDisabled()) {
            return;
        }
        var data = this.formData();
        this.disableForm();
        this.action(data, _.bind(function (response) {
            if (this.callback) {
                this.callback(response);
            }
            this.enableForm();
            if (response.success) {
                this.hideError();
            } else {
                var message;
                switch (response.message) {
                case 'hostname':
                    message = 'Please provide a valid <b>Hostname</b>';
                    break;
                case 'port':
                    message = 'Please provide a valid <b>Port</b>';
                    break;
                case 'nickname':
                    message = 'Please choose a valid <b>Nickname</b>';
                    break;
                case 'realname':
                    message = 'Please choose a valid <b>Real name</b>';
                    break;
                case 'passworded_servers':
                    message = '<a href="/?/upgrade">Upgrade now</a> to connect to passworded servers.';
                    break;
                case 'slack_disallowed':
                    message = '<a href="/?/upgrade">Upgrade now</a> to connect to Slack workspaces.';
                    break;
                case 'connection_unavailable':
                    message = 'This connection is temporarily unavailable. Try again later.';
                    break;
                case 'server_error':
                    message = 'There was a problem joining this network';
                    break;
                case 'too_many_connections':
                    message = 'You’ve exceeded the connection limit. Delete some connections before adding any more';
                    break;
                case 'restricted':
                    message = RenderReasons.renderRestricted(response.reason).replace(/<b>(.*)<\/b>/, '<a href="/?/upgrade">$1</a>');
                    break;
                case 'sts_policy':
                    message = 'You can’t disable secure connections to this network because it’s using a strict transport security policy';
                    break;
                default:
                    message = 'There was a problem joining this network: ' + this.formatter.escapeText(response.message);
                    break;
                }
                this.showError(message);
            }
        }, this));
    },
    serializeForm: function () {
        var data = this.$el.serializeForm();
        for (var k in this.nameMap) {
            if (k in data) {
                data[this.nameMap[k]] = data[k];
                delete data[k];
            }
        }
        if (this.extraFields) {
            $.extend(data, this.extraFields.serializeForm());
        }
        return data;
    },
    focusNick: function () {
        this.focusInput('Nick');
    },
    focusInput: function (input) {
        var inputEl = this.input(input);
        if (inputEl) {
            inputEl.focus().select();
        }
    },
    focusNetname: function () {
        this.focusInput('Netname');
    },
    focusNetwork: function () {
        if (this.networkComplete) {
            this.networkComplete.focus();
        }
    },
    focusChannels: function () {
        this.focusInput('Channels');
    },
    checkPort: function (port) {
        var port_s = util.stringify(port);
        if (this.lastPort !== port_s) {
            var plusMatches = port_s.match(/\+(\d+)/);
            if (plusMatches) {
                this.setSSL(true);
                this.lastPort = plusMatches[1];
                this.setInput('Port', plusMatches[1]);
            } else if (port_s == util.stringify(Connection.defaultSSLPort)) {
                this.lastPort = port_s;
                this.setSSL(true);
            } else if (port_s == util.stringify(Connection.defaultPort)) {
                this.lastPort = port_s;
                this.setSSL(false);
            }
        }
    },
    renderSelectComplete: function (container) {
        // Autodetect SSL port
        var portEl = this.input('Port');
        if (portEl) {
            portEl.on('input keyup update', _.bind(function (e) {
                this.checkPort(portEl.val());
            }, this));
        }
        // Setup network autocomplete
        var hostnameEl = this.input('Hostname');
        if (hostnameEl) {
            this.networkComplete = new SelectAutoComplete({
                el: hostnameEl,
                appendTo: container,
                className: this.classPrefix + 'Hostname',
                selectItem: _.bind(function (event, item) {
                    if (item.option) {
                        this.setHostname(item.option.data('hostname'));
                        this.setPort(item.option.data('port'));
                        this.setSSL(item.option.data('ssl'));
                    } else {
                        this.setHostname(item.value);
                    }
                    // Focus nick unless we tabbed or the entry is blank
                    if (item.value && event.which != 9) { // TAB
                        this.focusInput(this.tabFocus);
                    } else {
                        this.networkComplete.focus();
                    }
                }, this),
                selectTerm: _.bind(function (event, term) {
                    this.setHostname(term);
                }, this),
                footer: _.bind(function (term) {
                    return {
                        label: 'Choose a hostname and port…',
                        value: term,
                        className: 'autoCompleteFooter'
                    };
                }, this),
                optionMapper: _.bind(function (option, term, matcher) {
                    var opt = $(option);
                    if (opt.is('.placeholder')) {
                        return null;
                    }
                    var label = opt.text();
                    var hostname = opt.data('hostname');
                    if (label && (!term || label.match(matcher) || hostname.match(matcher))) {
                        var icon = opt.data('ssl') ? 'shield' : 'globe';
                        var formattedLabel = '<i class="fa fa-' + icon + '" title="Secure connection"></i> ' +
                            util.highlightTerm(label, term) +
                            ' <span class="host">' + util.highlightTerm(hostname, term) + '</span>';
                        return {
                            label: formattedLabel,
                            value: hostname,
                            option: opt
                        };
                    }
                }, this)
            });
        
            this.networkComplete.render();
        }
        
        return this;
    },
    setHostname: function (value) {
        var host, port;
        
        var bracketMatch = value.match(/\[([^\]]+)\](?::(\d+))?/);
        if (bracketMatch) {
            host = bracketMatch[1];
            port = bracketMatch[2];
        } else {
            var splitParts = value.split(':');
            if (splitParts.length == 2 && !isNaN(splitParts[1] - 0)) {
                host = splitParts[0];
                port = splitParts[1];
            } else {
                host = value;
            }
        }
        if (this.networkComplete) {
            this.networkComplete.setValue(host);
        }
        if (port) {
            this.setPort(port);
        }
    },
    setInput: function (input, value, options) {
        options = options || {};
        var inputEl = this.input(input);
        if (inputEl) {
            if (options.keep && inputEl.val()) {
                return;
            }
            inputEl.val(value);
            if (options.then) {
                options.then();
            }
        }
    },
    setPort: function (value) {
        this.setInput('Port', value, {
            then: _.bind(function () {
                this.checkPort(value);
            }, this)
        });
    },
    setAutoChannels: function (value) {
        this.setInput('Channels', value);
    },
    setAutoCommands: function (value) {
        this.setInput('Commands', value);
    },
    setUser: function (user) {
        if (user) {
            this.setRealname(user.getRealname(), {keep: true});
            this.setNickname(user.get('nick'), {keep: true});
        }
    },
    setNetname: function (value) {
        this.setInput('Netname', value);
    },
    setNetwork: function (connection) {
        this.setInput('Hostname', connection.getHost());
    },
    setNickname: function (value, options) {
        this.setInput('Nick', value, options);
    },
    setRealname: function (value, options) {
        this.setInput('Realname', value, options);
    },
    setSSL: function (value) {
        var sslEl = this.input('SSL');
        if (sslEl) {
            sslEl.prop('checked', !!value);
        }
    },
    setNickservPass: function (value) {
        this.setInput('Nspass', value);
    },
    setServerPassword: function (value) {
        this.setInput('Password', value);
    },
    setAvatar: function (connection) {
        if (this.avatar) {
            this.avatar.setModel(connection);
            if (connection.nativeAvatarUploadsSupported()) {
                this.avatar.show();
            } else {
                this.avatar.hide();
            }
        }
    },
    setConnection: function (connection) {
        this.setNetname(connection.getName());

        this.setNetwork(connection);
        
        this.setHostname(connection.get('hostname') || '');
        
        var ssl = !!connection.get('ssl');
        var port = connection.get('port') ||
            (ssl ? Connection.defaultSSLPort : Connection.defaultPort);
        this.setPort(port);
        this.setSSL(ssl);
        
        this.setAutoChannels('');

        this.setNickname(connection.get('nick'));
        this.setRealname(connection.get('realname'));
        
        this.setNickservPass(connection.get('nickserv_pass'));
        
        this.setServerPassword(connection.get('server_pass'));
        
        this.setAutoCommands(connection.get('join_commands'));

        this.setAvatar(connection);
    },
    hideError: function () {
        this.error.hide();
    },
    showError: function (message) {
        this.error.html(message).fadeIn('fast');
    },
    prefill: function (user, bufferParts) {
        this.setUser(user);
        if (bufferParts) {
            this.setHostname(bufferParts.hostname || '');

            var ssl = !!bufferParts.ssl;
            var port = bufferParts.port ||
                (ssl ? Connection.defaultSSLPort : Connection.defaultPort);
            this.setPort(port);
            this.setSSL(ssl);

            this.setAutoChannels(bufferParts.buffer || '');
        }
        this.setNickservPass('');
        this.setServerPassword('');
        this.setAutoCommands('');
        this.triggerLoad();
    },
    input: function (name) {
        return this.inputs[name];
    },
    cell: function (name) {
        return this.cells[name];
    },
    triggerLoad: function () {
        this.$el.triggerHandler('load');
    },
    render: function () {
        this.$el.attr('method', 'post');
        this.$el.attr('novalidate', true);
        this.$el.append('<input type="text" style="display:none;"><input type="password" style="display:none;">');
        
        this.renderCellGroups();
        
        return this;
    },
    renderCellGroups: function () {
        _.each(this.cellGroups, function (cellGroup, i) {
            // Container
            var container = this.$el;
            if (cellGroup.collapsed) {
                container = $('<div>')
                    .addClass('networkEditor__container networkEditor__container--collapsed')
                    .addClass(this.classPrefix + cellGroup.collapsed + 'Container');
                this.$el.append(container);
                this.containers[cellGroup.collapsed] = container;
            }
            
            // Heading
            if (cellGroup.heading) {
                var heading = this.buildCellHeading(cellGroup.heading, cellGroup.collapsed);
                if (heading) {
                    container.append(heading);
                }
            }
            
            if (cellGroup.cells) {
                var table = this.buildCellTable(cellGroup.cells, cellGroup.className);
                container.append(table);
            }

            if (cellGroup.after) {
                container.append(cellGroup.after);
            }
        }, this);
        
        // Error
        this.error = $('<p class="userError" tabindex="-1">').attr('id', this.idPrefix + 'Error');
        this.$el.append(this.error);
        
        // Submit
        this.submit = $('<p class="form">').addClass(this.classPrefix + 'Submit');
        this.submit.append($('<button class="action" type="submit">').append($('<span>').text(this.submitLabel)));
        if (this.cancel) {
            var cancelButton = $('<button type="button" class="cancel">').append($('<span>').text(this.cancelLabel)).on('buttonClick', _.bind(function (e) {
                this.cancel();
                return false;
            }, this));
            this.submit.append(cancelButton);
        }
        if (this.afterSubmit) {
            _.each(this.afterSubmit, function (el, i) {
                this.submit.append(el);
            }, this);
        }
        this.$el.append(this.submit);
        
        return this;
    },
    setSubmitLabel: function (label) {
        this.submitLabel = label;
        this.submit.find('button.action span').text(this.submitLabel);
    },
    setCancelLabel: function (label) {
        this.cancelLabel = label;
        this.submit.find('button.cancel span').text(this.cancelLabel);
    },
    toggleCollapsed: function (container) {
        this.containers[container].toggleClass('networkEditor__container--collapsed');
        this.trigger('collapsedChange', container);
    },
    buildCellHeading: function (options, collapsed) {
        if (!options) {
            return false;
        }
        var heading = $('<h2>');
        heading.addClass(this.classPrefix + 'Heading');
        heading.addClass('networkEditorHeading');
        if (options.className) {
            heading.addClass('networkEditorHeading__' + options.className);
            heading.addClass(this.classPrefix + options.className + 'Heading');
        }
        if (options.label) {
            var wrapper;
            if (collapsed) {
                wrapper = $('<a href="#">').click(_.bind(function (e) {
                    this.toggleCollapsed(collapsed);
                    return false;
                }, this));
            } else {
                wrapper = $('<span>');
            }
            heading.append(wrapper.html(options.label));
            if (options.icon) {
                wrapper.prepend('<i class="fa fa-' + options.icon + '">');
            }
        }
        return heading;
    },
    buildCellTable: function (cells, className) {
        var table = $('<table cellpadding="0" cellspacing="0" class="form">');
        table.addClass(this.classPrefix + 'Cells');
        table.addClass('networkEditorCells');
        if (className) {
            table.addClass('networkEditorCells__' + className);
        }
        var labels = $('<tr>');
        var inputs = $('<tr>');
        var hasLabels = false;
        _.each(cells, function (cell, j) {
            var inputAttrs = _.clone(cell.inputAttrs);
            if (j > 0 && cell.row) {
                // New row
                table.append(labels);
                table.append(inputs);
                labels = $('<tr>');
                inputs = $('<tr>');
            }
            var labelCell = $('<th>');
            var inputCell = $('<td>');
            if (cell.cellClass !== false) {
                // No prefix
                var cellClass = cell.cellClass || inputAttrs.name;
                labelCell.addClass(cellClass);
                inputCell.addClass(cellClass);
            }
            if (cell.colSpan) {
                labelCell.attr('colspan', cell.colSpan);
                inputCell.attr('colspan', cell.colSpan);
            }
            if (cell.optional) {
                labelCell.addClass('optional');
                inputCell.addClass('optional');
            }
            
            // Input
            var inputElement = cell.inputElement || 'input';
            var input;
            if (inputAttrs.type == 'avatar') {
                input = $($('#tpl-avatar-preview').html());
                this.avatar = new AvatarUploadPreview({
                    session: this.session,
                    el: input,
                    size: 32
                }).hide();
            } else {
                input = $(cell.input || ('<' + inputElement + '>'));
                if ($.inArray(inputAttrs.type, ['checkbox', 'radio']) === -1) {
                    input.addClass('input');
                }
            }
            var inputId;
            if (cell.inputClass) {
                input.addClass(this.classPrefix + cell.inputClass);
                inputId = cell.inputClass;
            }
            if (cell.inputId !== false) {
                inputId = cell.inputId || inputId;
                if (cell.inputIdSuffix) {
                    inputId += cell.inputIdSuffix;
                }
                input.attr('id', this.idPrefix + inputId);
            }
            if (cell.autocomplete) {
                input.attr('autocomplete', cell.autocomplete);
            }
            if (inputAttrs.type == 'password') {
                var newName = inputAttrs.name + '_' + util.ts();
                this.nameMap[newName] = inputAttrs.name;
                inputAttrs.name = newName;
            }
            input.attr(inputAttrs);
            if (inputId) {
                this.cells[inputId] = inputCell;
                this.inputs[inputId] = input;
            }
            inputCell.append(input);
            
            // Label
            if (cell.label) {
                var label = $('<label>').html(cell.label);
                if (inputId) {
                    label.attr('for', this.idPrefix + inputId);
                }
                labelCell.append(label);
                hasLabels = true;
            }


            if (inputAttrs.type == 'password' && cell.reveal) {
                var revealId = this.idPrefix + inputId + 'Reveal';
                var reveal = $('<span>')
                    .append(' ')
                    .append($('<input type="checkbox" class="reveal">').attr('id', revealId).data('input', input))
                    .append($('<label>').attr('for', revealId).text(' Reveal'));
                input.addClass('password');
                inputCell.append(reveal);
            }

            // After input
            if (cell.after) {
                var afterContents;
                if (_.isFunction(cell.after)) {
                    afterContents = cell.after(this.idPrefix + inputId);
                } else {
                    afterContents = cell.after;
                }
                var after = $(afterContents).addClass(this.classPrefix + 'after' + cell.inputClass);
                if (cell.afterLabel) {
                    after = $('<label>').append(after);
                    if (inputId) {
                        after.attr('for', this.idPrefix + inputId);
                    }
                }
                inputCell.append(after);
            }
            
            labels.append(labelCell);
            inputs.append(inputCell);
        }, this);
        if (hasLabels) {
            table.append(labels);
        }
        table.append(inputs);
        return table;
    }
});
NetworkEditor.CELLS = {
    channels: {
        row: true,
        optional: true,
        inputElement: "textarea",
        inputClass: "Channels",
        inputAttrs: {
            name: "channels",
            rows: 4,
            placeholder: "e.g. #chat, #feedback, #secretchat password1"
        },
        label: 'Channels to join <small class="explanation">— comma or line separated, password after a space</small>'
    },
    serverPass: {
        row: true,
        optional: true,
        inputClass: "Password",
        autocomplete: "new-password",
        inputAttrs: {
            name: "server_pass",
            type: "password"
        },
        label: 'Server password <small class="explanation">— (optional) for private servers <a href="/?/upgrade" class="passwordedWarning">upgrade required</a></small>',
        reveal: true
        
    }
};
NetworkEditor.CELL_GROUPS = {
    network: {
        className: 'network',
        cells: [{
            inputClass: "Hostname",
            inputAttrs: {
                name: "hostname"
            },
            label: "Hostname",
            input: '<select><option class="placeholder" value="">Choose a network…</option></select>'
        }, {
            inputClass: "Port",
            inputAttrs: {
                name: "port",
                value: Connection.defaultPort
            },
            label: "Port"
        }, {
            inputClass: "SSL",
            inputAttrs: {
                name: "ssl",
                type: "checkbox",
                value: "1"
            },
            after: '<span><i class="fa fa-shield" title="Use a secure connection to this server"></i>Secure port</span>',
            afterLabel: true
        }]
    },
    identity: {
        heading: {
            icon: 'user',
            className: "Identity",
            label: "Your identity"
        },
        cells: [{
            inputClass: "Nick",
            inputAttrs: {
                name: "nickname"
            },
            label: "Nickname"
        }, {
            inputClass: "Realname",
            inputAttrs: {
                name: "realname",
                placeholder: "optional"
            },
            label: "Full name (optional)"
        // }, {
        //     inputClass: "Avatar",
        //     inputAttrs: {
        //         type: "avatar"
        //     }
        }]
    },
    channels: {
        heading: true,
        cells: [NetworkEditor.CELLS.channels]
    },
    advanced: {
        heading: {
            icon: 'cog',
            className: "Advanced",
            label: "Advanced options"
        },
        collapsed: "Advanced",
        cells: [{
            row: true,
            optional: true,
            inputClass: "Nspass",
            autocomplete: "new-password",
            inputAttrs: {
                name: "nspass",
                type: "password"
            },
            label: 'NickServ password <small class="explanation">— if the server supports it and you’ve registered your nickname</small>',
            reveal: true
        }, {
            row: true,
            optional: true,
            inputElement: "textarea",
            inputClass: "Commands",
            inputAttrs: {
                name: "joincommands",
                rows: 4,
                placeholder: "AUTH <user> <password> etc..."
            },
            label: 'Commands to run on connect <small class="explanation">— one per line, e.g. for opering up on connect.<br>' +
                   'If you need to add a (eg, 15 sec) delay between commands, you can write: WAIT 15</small>'
        },
        NetworkEditor.CELLS.serverPass
        // , {
        //     row: true,
        //     optional: true,
        //     inputClass: "Username",
        //     inputAttrs: {
        //         name: "username"
        //     },
        //     label: 'Custom username <small class="explanation">— used on some servers for identity and authentication</small>'
        // }
        ]
    },
    slack: {
        after: require('./add-slack.hbs')()
    },
    netname: {
        cells: [{
            inputClass: "Netname",
            inputAttrs: {
                name: "netname"
            },
            label: "Name"
        }]
    },
};


module.exports = NetworkEditor;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/networkeditor.js
// module id = 0xAE
// module chunks = 1